<template>
  <div>
    <base-spinner v-if="loading"></base-spinner>
    <div v-else-if="noAdmins">{{ $t('src/components/hospitaladmins.6765') }}</div>
    <ul v-else class="inline-list">
      <li v-for="admin in admins" :key="admin.id" class="inline-list__item">
        <div class="d-flex justify-content-between align-items-center">
          {{ getSurnameWithInitials(admin) }}
          <span v-if="isUnregister(admin.status)" class="text-warning">{{
            $t('src/components/hospitaladmins.7784')
          }}</span>
          <span v-if="isBlocked(admin.status)" class="text-danger">{{
            $t('src/components/hospitaladmins.1141')
          }}</span>
          <router-link
            :to="{
              name: 'user-edit',
              query: { hospital: hospitalId },
              params: { id: admin.id }
            }"
            class="btn btn-link btn-icon icon icon-edit icon_primary"
          >
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import http from '@/modules/http.js'
import { roles } from '@/main.config.js'
import { fullName } from '@/mixins/full-name.js'
import { userStatus } from '@/main.config'

export default {
  name: 'HospitalAdmins',
  mixins: [fullName],
  components: {
    BaseSpinner: () => import('@/base/BaseSpinner.vue')
  },
  props: {
    hospitalId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    loading: true,
    admins: null
  }),
  computed: {
    noAdmins() {
      return !this.admins.length
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    isUnregister(status) {
      return status === userStatus.unregistered
    },
    isBlocked(status) {
      return status === userStatus.blocked
    },
    loadData() {
      this.loading = true

      http
        .get('/users', {
          params: {
            'user_role.title': roles.hospital,
            hospital_id: this.hospitalId
          }
        })
        .then(response => {
          this.admins = response.data.data
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
